/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Legal_Footer_Last_UpdatedInputs */

const tr_legal_footer_last_updated = /** @type {(inputs: Legal_Footer_Last_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Son güncelleme: ${i?.date}`)
};

const en_legal_footer_last_updated = /** @type {(inputs: Legal_Footer_Last_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last updated: ${i?.date}`)
};

const de_legal_footer_last_updated = /** @type {(inputs: Legal_Footer_Last_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Letzte Aktualisierung: ${i?.date}`)
};

const ru_legal_footer_last_updated = /** @type {(inputs: Legal_Footer_Last_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Последнее обновление: ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Last updated: {date}" |
*
* @param {Legal_Footer_Last_UpdatedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const legal_footer_last_updated = /** @type {((inputs: Legal_Footer_Last_UpdatedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Footer_Last_UpdatedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_footer_last_updated(inputs)
	if (locale === "de") return de_legal_footer_last_updated(inputs)
	if (locale === "ru") return ru_legal_footer_last_updated(inputs)
	return tr_legal_footer_last_updated(inputs)
});